import React, { useEffect, useState } from "react";

import { SupplierUnconfirmedOrdersStyle } from "./SupplierUncofirmedOrdersStyle";
// use hooks
import { useNotApprovedOrderOnline } from "../../hooks/useAccounting";

// components
import Button from "../../components/Button/Button";
import { Table } from "../../components/Table/Table";

// styled components

import Loading from "../../components/Loadings/LoadingTable";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
const SupplierUnconfirmedOrders = () => {
  const [PageNumber, setPageNumber] = useState(1);

  const { data, isLoading, hasNextPage, fetchNextPage } =
    useNotApprovedOrderOnline(PageNumber);

  const allApprove = data;
  const count = data?.pages[0]?.data?.NotApprovedNumber;
  const headerTitle = [
    "نام و نام خانوادگی",
    "شماره تماس",
    "کد پیگیری",
    "تاریخ و ساعت",
    "مبلغ کل",
    "مبلغ پرداخت شده",
    // "عملیات",
    "جزییات",
  ];

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = allApprove?.pages?.map((page) =>
    page?.data?.NotApprovedOrderOnline?.map((item) => (
      <tr key={item.IdOrderOnline}>
        <td>
          <div className="d-flex align-items-center">
            <div className="symbol symbol-45px ">
              <img src="" alt="" />
            </div>
            <div className="d-flex justify-content-start flex-column">
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item.FirstName + " " + item.LastName}
              </span>
            </div>
          </div>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item.Phone}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item.IdShowUserOrderOnline}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {MiladiToShamsi(item.created_at)}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item.PriceAll}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item.DepositAll}
          </span>
        </td>
        <td>
          <Button size="12px" bgColor="#0D6EFD" small="100px" color="#fff">
            جزییات
          </Button>
        </td>
      </tr>
    ))
  );

  if (isLoading) {
    return <Loading />;
  }
  return (
    <SupplierUnconfirmedOrdersStyle className="mt-3">
      <Table
        title={`سفارش های تایید نشده (${count})`}
        items={items}
        headerTitle={headerTitle}
      />
    </SupplierUnconfirmedOrdersStyle>
  );
};

export default SupplierUnconfirmedOrders;
